import React, { FC, useEffect, useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  Tooltip,
} from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormCheckboxField: FC<FormFieldProps> = (props) => {
  console.log("props", props);
  const classes = useStyles();
  const [checked, setChecked] = useState(props.checked ? props.checked : false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("event", event.target.checked, props.onChange);
    setChecked(event.target.checked);
    if (props.onChange) {
      props.onChange({
        target: {
          id: event.target.id,
          value: event.target.checked,
          checked: event.target.checked,
        },
      });
    }
  };

  useEffect(() => {
    setChecked(Boolean(props.checked));
  }, [props.checked]);

  const inputRender = () => {
    const hasError = Boolean(props?.error);

    return (
      <>
        <FormControlLabel
          disabled={props?.disabled}
          sx={{
            ...(hasError
              ? {
                  color: "#d32f2f",
                }
              : {}),
          }}
          control={
            <Checkbox
              sx={{
                marginLeft: "16px",
                ...(hasError
                  ? {
                      color: "#d32f2f",
                      "&.Mui-checked": {
                        color: "#d32f2f",
                      },
                    }
                  : {}),
              }}
              checked={checked}
              onChange={handleChange}
              name={props.id}
              id={props.id}
              color={hasError ? "error" : "primary"}
            />
          }
          label={props?.checkLabel ? props.checkLabel : ""}
        />
        {hasError && props?.helperText && (
          <FormHelperText sx={{ color: "#d32f2f", marginLeft: "16px" }}>
            {props?.helperText}
          </FormHelperText>
        )}
      </>
    );
  };

  return (
    <>
      {props.label && !props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5}
            className={classes.labelBox}
            sx={{ marginBottom: "10px" }}
          >
            <InputLabel
              sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
              shrink
              htmlFor={props.id}
            >
              {props.label}
              {props?.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Grid>
          <Grid
            item
            xs={12}
             sm={props?.md ? props?.md : 7}
            style={{
              padding: "0px",
              display: "flex",
              justifyContent: "start",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            {inputRender()}
          </Grid>
        </>
      ) : props?.label && props?.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 12}
            sx={{
              display: "block",
              alignItems: "center",
              gap: 2,
              ...props?.GridFieldStyle,
            }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{
                  color: "#637381",
                  fontWeight: 600,
                  fontSize: "16px",
                  textAlign: "left !important",
                }}
                shrink
                htmlFor={props?.id}
              >
                {props?.label}
                {props?.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
            {inputRender()}
          </Grid>
        </>
      ) : (
        inputRender()
      )}
    </>
  );
};

export default FormCheckboxField;
